/* eslint-disable array-callback-return */
// 通知详情
import React, { useCallback, useEffect, useState, useContext } from "react";
import "./index.less";
import { Drawer, Popover, Tabs, Button, Empty, message as toast } from "antd";
import { Avatar } from "@/baseComponents/Avatar";
import IconFont from "@/components/icon";
import { ChatMessage } from "@/types/chat";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";
import { EsuperviseSourceType, ICreateSuperviseData } from "@/types/supervise";
import { CalendarIcon } from "@/components/Calendars/Common";
import { connect } from "dva";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { getFileIconByMime, getFileUrl, downLoadFile as downLoadFileWeb } from "@/utils/chat/index";
import {
  buildJoyspaceIconUrl,
  buildPagePathKey
} from "@/components/Modals/JoyspaceFileSelectorModal/utils";
import { replaceGovUrl } from "@/utils/joyspace";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { isFocusEnv, FocusSDK } from "@/utils";
import { formate } from "@/utils/date";
import ChatState from "@/types/chat/State";
import bus from "@/utils/bus";
import {
  notificationAuthCode,
  queryNotificationDetail,
  RespondToNotificationReq
} from "@/api/notification";
import noticeImg from "@/assets/img/no-content.png";
import ImService from "@/server/ImService";
import { ChatMessageExtType } from "@jd/jdee.im.sdk/lib/es/protocol/messageExtend/Type";
import { buildGroupMessageBody, FILE_DOWNLOAD_BIZTYPE } from "@/utils/chat/message";
import { changeEgovUrl } from "@/utils/tools";
import CopyFrame from "@/components/CopyFrame";
import colors from "@/components/styles/colors";
import DownloadService from "@/server/DownloadService";
import { analysisLog } from "@/utils/logAnalytics";
import { canJoyspacePreview, openJoyspacePreview } from "@/components/Joyspace/util";

const { TabPane } = Tabs;

interface NoticeDetailsMsg {
  message?: ChatMessage;
  openCreateSuperviseModal: (opt: { visible: boolean; createData: ICreateSuperviseData }) => void;
  openNoticeDetails: (data: { isvisibles: boolean; notificationId: any }) => void;
  openNoticeDetailsHis: (data: { isvisibles: boolean; sessionId: any }) => void;
}

type IProps = Readonly<NoticeDetailsMsg & ChatState>;
// eslint-disable-next-line complexity
function NoticeDetails(props: IProps) {
  const {
    message,
    openCreateSuperviseModal,
    sessionMessageMap,
    currentEmployee,
    allSessionList,
    NoticeDetailsVisible,
    notificationId,
    openNoticeDetails,
    openNoticeDetailsHis,
    type
  } = props;
  const downloadServiceInstance = DownloadService.getInstance({});
  const [isvisible, setIsvisible] = useState(false);
  const [getScheduleInfos, setGetScheduleInfos] = useState<any>();
  const [newUsers, setNewUsers] = useState<any>([]);
  const [btnstyle, setbtnstyle] = useState({ display: "block" });
  const { t } = useTranslation("chat");
  const {
    appRuntimeEnv: { joyspaceApiHost, joyspaceHost }
  } = useContext<GlobalContextConfig>(GlobalContext);
  const instance = ImService.getInstance();
  let noticeType: any = type;

  const onClose = () => {
    openNoticeDetails({
      isvisibles: false,
      notificationId: ""
    });
    setGetScheduleInfos(undefined);
  };

  // 响应回复
  const sendMessages = async () => {
    let msg = sessionMessageMap[getScheduleInfos?.sourceBizId];
    let optionId: any;
    let msgs: any = message;
    getScheduleInfos?.optionList.map((item: any) => {
      optionId = item.optionId;
    });
    msg?.map((item: any) => {
      item?.optionList?.map((item1: any) => {
        if (item1.optionId === optionId) {
          msgs = item;
        }
      });
    });
    if (message === undefined) {
      const [data, err] = await RespondToNotificationReq({
        notificationId: getScheduleInfos?.notificationId,
        optionId: optionId
      });
      if (err) {
        toast.error(err);
        return;
      }
      const newDate = new Date().getTime();
      let sessions: any;
      let users = {
        app: currentEmployee.app,
        clientType: "pc",
        name: currentEmployee.name,
        nickName: currentEmployee.name,
        pin: currentEmployee.userId,
        teamId: currentEmployee.teamId,
        optionId: getScheduleInfos?.optionList[0].optionId,
        timestamp: newDate
      };
      // eslint-disable-next-line array-callback-return
      allSessionList.filter((item: any) => {
        if (item.sessionId === getScheduleInfos?.sourceBizId) {
          sessions = item;
        }
      });
      let msgContentItem = {
        users: [users]
      } as any;
      const msgType = ChatMessageExtType.GROUP_NOTICE;
      const datas = buildGroupMessageBody({
        msgType,
        session: sessions,
        mid: Number(getScheduleInfos?.mid),
        msgContentItem
      });
      await instance.sendChatMessageExt(getScheduleInfos?.sourceBizId, datas as any);
      onClose();
    } else {
      bus.emit("chat:message-groupnotificationcard", msgs);
    }
  };

  // 查询详情
  const GroupNotification = useCallback(async () => {
    // notificationId = _notificationId;
    const [data, err] = await queryNotificationDetail({ notificationId: notificationId });
    if (err) {
      openNoticeDetails({
        isvisibles: false,
        notificationId: ""
      });
      setGetScheduleInfos(undefined);
      toast.error(err);
      return;
    }
    if (data) {
      setGetScheduleInfos(data);
      if (data.unReadMemberList === null) return;
      if (data.readMemberList.length === 0) {
        setNewUsers(data.unReadMemberList);
        return;
      }
      setNewUsers(data.readMemberList[0].memberList?.concat(...data.unReadMemberList));
      return;
    }
  }, [notificationId, openNoticeDetails]);

  useEffect(() => {
    if (NoticeDetailsVisible === false) {
      // notificationId = '';
      // setGetScheduleInfos(undefined);
      setNewUsers([]);
      return;
    }
    GroupNotification();
  }, [GroupNotification, NoticeDetailsVisible, notificationId]);

  function visibleChange(visible: boolean) {
    setIsvisible(visible);
    setbtnstyle({ display: "block" });
  }

  // 打开催办
  function handleOpenRecord(advanceUser: any, value: any) {
    const userList: any[] = [];
    if (advanceUser.length === undefined) {
      // eslint-disable-next-line array-callback-return
      // advanceUser.map((item: any) => {
      // console.log('advanceUser', item);
      userList.push({
        userId: advanceUser?.userId,
        teamId: advanceUser?.teamId,
        appId: advanceUser?.appId,
        headImg: advanceUser?.headImg,
        realName: advanceUser?.realName
      });
      // });
    } else {
      advanceUser.map((item: any) => {
        userList.push({
          userId: item?.userId,
          teamId: item?.teamId,
          appId: item?.appId,
          headImg: item?.headImg,
          realName: item?.realName
        });
      });
    }
    console.log("打开催办", userList);
    openCreateSuperviseModal({
      visible: true,
      createData: {
        id: notificationId,
        title: value,
        userList,
        from: EsuperviseSourceType.NOTIFICATION
      }
    });
    setIsvisible(false);
    onClose();
  }

  // 文件icon
  const getAttachmentIcon = (item: any) => {
    const { fileType, fileName } = item;
    if (fileType?.startsWith("joyspace")) {
      try {
        const strs = fileType.split("/");
        if (strs[1] === "6") {
          return getFileIconByMime(strs.slice(2).join("/") || "application/octet-stream")[0];
        } else {
          return buildJoyspaceIconUrl({
            title: fileName,
            pageType: strs[1],
            type: strs.slice(2).join("/") || "",
            apiHost: joyspaceApiHost
          });
        }
      } catch (error) {
        return getFileIconByMime(fileType || "application/octet-stream")[0];
      }
    }
    return getFileIconByMime(fileType || "application/octet-stream")[0];
  };

  // 文件下载
  async function downloadFile(item: any, num: boolean) {
    // if (item.status === FileStatus.Uploading) {
    //     return;
    // }
    console.log("downloadFile-gtoup=>", item);
    if (item.fileType?.startsWith("joyspace")) {
      const path = buildPagePathKey(Number(item.fileType.split("/")[1])).subPath;
      let newUrl = `${joyspaceHost}/${path}/${item.fileId}`;
      let realUrl = replaceGovUrl(newUrl);
      analysisLog("xtbg_jzb_joysapce_inOtherModule_1676971574856", "19", path, item.fileId);
      return DeeplinkEvent.open(realUrl);
    }
    if (canJoyspacePreview(item?.fileName) && num) {
      const opt = {
        notificationId: notificationId || getScheduleInfos.notificationId || "",
        fileId: item.fileId || ""
      };
      const [res, err] = await notificationAuthCode(opt);
      if (err) {
        return toast.error(err);
      }
      console.log("获取code", res);
      openJoyspacePreview({
        code: res,
        host: joyspaceHost,
        isShowHeader: 1,
        canSaveToJoyspace: 1,
        canDownload: 1
      });
      return;
    }
    if (isFocusEnv()) {
      downloadServiceInstance.download(
        {
          viewFile: false,
          saveAs: true,
          message: {
            ...item,
            mid: item.fileId,
            id: item.fileId,
            url: item.fileUrl,
            notificationId: notificationId || getScheduleInfos.notificationId || ""
          },
          auto: false,
          isGroup: false
        },
        {
          onStarted: () => {},
          onProgress: () => {},
          onCancel: () => {
            // console.log('onCancel ==>取消下载');
          },
          onPause: () => {
            // console.log('onPause ==> 暂停下载');
          },
          onResume: () => {
            // console.log('onResume ==> 恢复下载');
          },
          onFinish: (file: { path: string; filename: string }) => {},
          onError: () => {}
        }
      );
      // FocusSDK.downloadFile(item.fileUrl, {
      //     saveAs: true,
      //     filename: item.fileName,
      //     onStarted: () => {},
      //     onProgress: () => {},
      //     onCancel: () => {
      //         // console.log('onCancel ==>取消下载');
      //     },
      //     onPause: () => {
      //         // console.log('onPause ==> 暂停下载');
      //     },
      //     onResume: () => {
      //         // console.log('onResume ==> 恢复下载');
      //     },
      //     onFinish: (file: { path: string; filename: string }) => {},
      // });
    } else {
      // web 端下载文件
      const name = item.fileName;
      const url = getFileUrl(item.fileUrl, {
        bizType: FILE_DOWNLOAD_BIZTYPE.groupnotice,
        bizId: notificationId || getScheduleInfos.notificationId || ""
      });
      downLoadFileWeb(name, url);
    }
  }

  const onTabchange = (activeKey: any) => {
    if (activeKey === "0") {
      setbtnstyle({ display: "block" });
    } else {
      setbtnstyle({ display: "none" });
    }
  };

  const openHistory = () => {
    openNoticeDetailsHis({
      isvisibles: true,
      sessionId: getScheduleInfos?.sourceBizId
    });
    onClose();
  };

  if (!getScheduleInfos) return null;

  const tabList = [
    `未回复 ${getScheduleInfos.unansweredNum}`,
    `已回复 ${getScheduleInfos.repliedNum}`
  ];

  const tabs = (
    <div onClick={(e) => e.stopPropagation()} style={{ height: "100%" }}>
      {getScheduleInfos && (
        <Tabs onChange={(activeKey) => onTabchange(activeKey)} tabBarGutter={70}>
          {tabList.map((tabItem, inx) => {
            const user =
              inx === 0
                ? getScheduleInfos?.unReadMemberList
                : getScheduleInfos.readMemberList[0]?.memberList;
            if (!user || user?.length === 0) {
              return (
                <TabPane tab={tabItem} key={inx}>
                  <div className="empty_item">
                    <Empty
                      image={noticeImg}
                      imageStyle={{
                        height: 100
                      }}
                      description={<span style={{ color: "#62656D" }}>暂无数据</span>}
                    />
                  </div>
                </TabPane>
              );
            }
            return (
              <TabPane tab={tabItem} key={inx}>
                {user.map((item: any, index: any) => {
                  if (item === undefined) return null;
                  let dept = "";
                  let proTitle = "";
                  if (item.labelInfoList?.[1]) {
                    dept = item.labelInfoList[1].name;
                  }
                  if (item.labelInfoList?.[2]) {
                    proTitle = item.labelInfoList[2].name;
                  }
                  return (
                    <div
                      className="NoticeDetails_user"
                      key={index}
                      // onClick={(e) => {
                      //     e.stopPropagation();
                      //     openUserCard(item);
                      // }}
                    >
                      <div className="NoticeDetails_left">
                        <Avatar
                          className="imgAvatar"
                          name={item.realName || ""}
                          src={changeEgovUrl(item.headImg)}
                          // onClick={() => openUserCard(item)}
                        />
                        <div className="NoticeDetails_left_user">
                          <span className="NoticeDetails_left_name ellipsis">{item.realName}</span>
                          <span className="NoticeDetails_left_dept ellipsis">{`${dept}-${proTitle}`}</span>
                        </div>
                      </div>
                      {inx === 0 && getScheduleInfos?.ownerUserId === currentEmployee.userId && (
                        <div
                          className="NoticeDetails_right"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleOpenRecord(item, getScheduleInfos?.content);
                          }}
                        >
                          催办
                        </div>
                      )}
                    </div>
                  );
                })}
                {inx === 0 && getScheduleInfos?.ownerUserId === currentEmployee.userId ? (
                  <div className="NoticeDetails_button" style={btnstyle}>
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      onClick={debounce(() => {
                        handleOpenRecord(
                          getScheduleInfos.unReadMemberList,
                          getScheduleInfos?.content
                        );
                      }, 500)}
                    >
                      全部催办
                    </Button>
                  </div>
                ) : null}
              </TabPane>
            );
          })}
        </Tabs>
      )}
    </div>
  );

  const footer = (
    <Button
      block
      type="primary"
      htmlType="submit"
      disabled={getScheduleInfos?.readFlag === 0 ? false : true}
      onClick={debounce(() => {
        sendMessages();
      }, 500)}
    >
      {getScheduleInfos?.readFlag === 0 ? "收到" : "已回复"}
    </Button>
  );

  return (
    <Drawer
      className="NoticeDetails"
      width={445}
      title="通知详情"
      placement="right"
      onClose={() => {
        onClose();
      }}
      visible={NoticeDetailsVisible}
      style={{ position: "absolute", right: 0, zIndex: 1029 }}
      footer={
        getScheduleInfos !== undefined &&
        currentEmployee.userId !== getScheduleInfos?.ownerUserId &&
        footer
      }
    >
      {getScheduleInfos === undefined ? (
        <div />
      ) : (
        <div className="NoticeDetails_box">
          <div className="NoticeDetails_title">
            <Avatar
              className="imgAvatar"
              name={getScheduleInfos?.realName || ""}
              src={changeEgovUrl(getScheduleInfos?.headImg)}
            />
            <div className="NoticeDetails_name">
              <span className="NoticeDetails_name_item">{getScheduleInfos?.realName}</span>
              <span>发布于 {formate(getScheduleInfos?.gmtCreate)}</span>
            </div>
          </div>
          <div className="NoticeDetails_user">
            <span style={{ whiteSpace: "nowrap", color: `${colors.black2}` }}>接收人：</span>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                cursor: "pointer"
              }}
              onClick={() => {
                setIsvisible(true);
              }}
            >
              <div className="NoticeDetails_user1" id="NoticeDetails_user1">
                {/* {newUsers?.map((item: any, index: any) => {
                                return (
                                    <span key={index}>
                                        {item.realName}
                                        {newUsers?.length === 1 ||
                                        newUsers[newUsers?.length - 1] === item
                                            ? ''
                                            : '、'}
                                    </span>
                                );
                            })} */}
                <span>共{newUsers?.length}人</span>
                <span>
                  （已回复{getScheduleInfos.repliedNum}
                  人， 未回复{getScheduleInfos.unansweredNum}人）
                </span>
              </div>
              <Popover
                overlayClassName={
                  btnstyle.display === "block" &&
                  getScheduleInfos?.ownerUserId === currentEmployee.userId
                    ? "NoticeDetails_Popover"
                    : "NoticeDetails_Popover1"
                }
                trigger="click"
                placement="bottom"
                content={tabs}
                onVisibleChange={visibleChange}
                visible={isvisible}
              >
                <div className="NoticeDetails_user2">
                  {/* <span>{getScheduleInfos.repliedNum} 人回复</span> */}
                  <IconFont
                    className="NoticeDetails_icon"
                    type="iconic_profile_next"
                    clstag="pageclick|keycount|focus_chat_01_1602584371145|47"
                  />
                </div>
              </Popover>
            </div>
          </div>
          {isFocusEnv() ? (
            <CopyFrame>
              <div className="NoticeDetails_con" id="NoticeDetails_con">
                <p style={{ whiteSpace: "pre-wrap" }}>{getScheduleInfos.content}</p>
              </div>
            </CopyFrame>
          ) : (
            <div className="NoticeDetails_con" id="NoticeDetails_con">
              <p style={{ whiteSpace: "pre-wrap" }}>{getScheduleInfos.content}</p>
            </div>
          )}

          {getScheduleInfos.attachmentList?.map((item: any, index: any) => {
            return (
              <div
                key={index}
                className="NoticeDetails_list"
                onClick={() => {
                  console.log("ssss=>", item);
                  downloadFile(item, true);
                }}
              >
                <div style={{ display: "flex", alignItems: "center", width: "94%" }}>
                  <span style={{ display: "flex" }}>
                    <CalendarIcon
                      src={getAttachmentIcon(item)}
                      className="left"
                      width={12}
                      height={12}
                    />
                  </span>
                  <span className="ellipsis" style={{ marginLeft: "8px" }}>
                    {item.fileName}
                  </span>
                </div>
                {!item.fileType?.startsWith("joyspace") && (
                  <IconFont
                    type="iconic_pc_calender_download"
                    className="download-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      downloadFile(item, false);
                    }}
                    style={{
                      width: "14px",
                      height: "14px",
                      marginLeft: "8px"
                    }}
                  />
                )}
              </div>
            );
          })}
          {noticeType !== "history" && (
            <div
              className="GroupNotification_lishi"
              style={{
                bottom: currentEmployee.userId === getScheduleInfos?.ownerUserId ? "18px" : "70px"
              }}
              onClick={openHistory}
            >
              <p>{t("group_history")}</p>
            </div>
          )}
        </div>
      )}
    </Drawer>
  );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  const {
    sessionMessageMap,
    currentEmployee,
    selectedSession,
    allSessionList,
    NoticeDetailsVisible,
    notificationId,
    type
  } = chat;
  return {
    sessionMessageMap,
    currentEmployee,
    selectedSession,
    allSessionList,
    NoticeDetailsVisible,
    notificationId,
    type
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateSuperviseModal: (opt: { visible: boolean; createData: ICreateSuperviseData }) => {
      dispatch({
        type: "supervise/setCreateModalVisible",
        payload: opt
      });
    },
    updateSessionMessageMid(data: { sendResult: any; sessionId: String }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    openNoticeDetails(data: { isvisibles: boolean; notificationId: any }) {
      dispatch({ type: "chat/openNoticeDetails", payload: data });
    },
    openNoticeDetailsHis(data: { isvisibles: boolean; sessionId: any }) {
      dispatch({ type: "chat/openNoticeDetailsHis", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NoticeDetails);
